import { Badge, Text } from '@stone-payments/jade';
import { useIntl } from 'react-intl';
import { GridContainer, GridItem } from './detailCheckoutItem.styles';

type CheckoutItemProps = {
  name: string;
  description: string;
  unit: number;
  unitDescription: string;
  value: string;
  isLast?: boolean;
};

export function CheckoutItem({
  name,
  description,
  unit,
  unitDescription,
  value,
  isLast,
}: CheckoutItemProps) {
  const { formatMessage } = useIntl();
  return (
    <GridContainer>
      <GridItem>
        <Text color="high" variant="text-medium" weight="semibold">
          {name}
        </Text>
      </GridItem>
      <GridItem>
        <Text color="medium">{description}</Text>
      </GridItem>
      <GridItem removeLastPaddingBottom={isLast}>
        <Badge
          variant="text"
          label={`${unit} ${formatMessage({ id: unitDescription })}`}
          voice="brand"
        />
        <Text variant="text-medium" weight="bold">
          {value}
        </Text>
      </GridItem>
    </GridContainer>
  );
}
